const HowItWorks = () => {
  return (
    <>
      <section
        className="workSec padSec overHide pt-0"
        id="work"
      >
        <div className="container">

          <div className="workSectionHead text-center">
            <span className="workEyebrow">
              TRUST BITCOIN TRAVEL
            </span>

            <h2>
              How It <span>Works</span>
            </h2>

            <p>
              Join the Trust Bitcoin ecosystem, participate
              through referrals, earn Travel Points, and use
              your eligible points toward available travel
              opportunities.
            </p>
          </div>

          <div className="workSteps">

            <div className="workStep">
              <div className="workStepIcon">
                <i className="fa-solid fa-shield-halved"></i>
                <span>01</span>
              </div>

              <div className="workStepContent">
                <h4>Join the Ecosystem</h4>

                <p>
                  Get started with Trust Bitcoin by becoming
                  a Validator or by participating through TBC.
                  Choose the participation path that suits you
                  and become part of the Trust Bitcoin
                  ecosystem.
                </p>

                <div className="workTag">
                  <i className="fa-solid fa-user-check"></i>
                  Become a Validator or Participate with TBC
                </div>
              </div>
            </div>

            <div className="workStep">
              <div className="workStepIcon">
                <i className="fa-solid fa-users"></i>
                <span>02</span>
              </div>

              <div className="workStepContent">
                <h4>Refer & Earn Travel Points</h4>

                <p>
                  Introduce the Trust Bitcoin ecosystem to
                  your community through the referral program.
                  Eligible referral activity can contribute
                  toward Travel Points according to the
                  applicable program rules.
                </p>

                <div className="workPointExample">
                  <div>
                    <small>Your Participation</small>

                    <strong>
                      <i className="fa-solid fa-user-plus"></i>
                      Refer
                    </strong>
                  </div>

                  <i className="fa-solid fa-arrow-right"></i>

                  <div>
                    <small>Your Benefit</small>

                    <strong className="gold">
                      <i className="fa-solid fa-star"></i>
                      Travel Points
                    </strong>
                  </div>
                </div>

                <div className="workNote">
                  <i className="fa-solid fa-circle-info"></i>
                  Referral activity and applicable rewards are
                  processed according to the Trust Bitcoin
                  ecosystem rules and smart-contract logic.
                </div>
              </div>
            </div>

            <div className="workStep">
              <div className="workStepIcon">
                <i className="fa-solid fa-ticket"></i>
                <span>03</span>
              </div>

              <div className="workStepContent">
                <h4>Redeem Your Travel Points</h4>

                <p>
                  Use your eligible Travel Points to access
                  available travel opportunities within the
                  Trust Bitcoin ecosystem. Explore available
                  tours, review their requirements, and redeem
                  your qualifying points for the journey that
                  suits you.
                </p>

                <div className="workFeatures">
                  <span>
                    <i className="fa-solid fa-star"></i>
                    Check Points
                  </span>

                  <span>
                    <i className="fa-solid fa-plane-departure"></i>
                    Explore Tours
                  </span>

                  <span>
                    <i className="fa-solid fa-ticket"></i>
                    Redeem Points
                  </span>
                </div>
              </div>
            </div>

            <div className="workStep">
              <div className="workStepIcon">
                <i className="fa-solid fa-plane"></i>
                <span>04</span>
              </div>

              <div className="workStepContent">
                <h4>Unlock Your Travel Experience</h4>

                <p>
                  Once you meet the applicable tour
                  requirements, complete the required
                  verification and travel documentation to
                  proceed with your selected travel
                  opportunity, subject to availability and
                  eligibility.
                </p>

                <div className="workTag success">
                  <i className="fa-solid fa-plane"></i>
                  Earn • Redeem • Travel
                </div>
              </div>
            </div>

          </div>

          <div className="workBottom">
            <div className="workBottomIcon">
              <i className="fa-solid fa-star"></i>
            </div>

            <div>
              <h4>How Travel Points Work</h4>

              <p>
                Travel Points are connected to eligible
                participation within the Trust Bitcoin
                ecosystem. Your available points can be used
                toward qualifying travel opportunities based
                on the requirements shown for each tour.
                Eligibility, availability, verification, and
                applicable program rules may apply.
              </p>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default HowItWorks;
